import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SvAppModule } from '@app/sv/sv.modules';
import { AttachmentTypeCategoryEnum, documentTypeCategoryOptions } from '@app/sv/enums/attachment-type-category.enum';


@Pipe({ name: 'documentTypeCategoryName' })
@Injectable({
  providedIn: 'root'
})
export class DocumentTypeCategoryNamePipe implements PipeTransform {
  transform(value: AttachmentTypeCategoryEnum): string {
    const option = documentTypeCategoryOptions.find(option => option.id === value);
    return option.name;
  }
}
